module.exports = __webpack_public_path__ + "img/dianfei_p.ca910637.png";